<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import AnalyticsPanel from '../analytics/AnalyticsPanel.vue';
import MetricValue from '../analytics/MetricValue.vue';
import { useAnalyticsFormat } from '../analytics/useAnalyticsFormat';
import { campanhasLabel } from './campanhasLabels';

// Quanto tempo do envio até entregar, ler e responder: a mediana (metade foi
// mais rápida) e o p90 (nove em dez). Entregar e ler dependem da captura: sem
// amostra, o tempo é nulo com o motivo, e não zero.
const props = defineProps({
  // `times` de GET campanhas/resumo; null enquanto não chegou.
  times: { type: Object, default: null },
  failed: { type: Boolean, default: false },
});

const { t } = useI18n();
const { number, duration } = useAnalyticsFormat();

const ROWS = [
  { key: 'to_deliver', label: 'CAMPANHAS.TIMES.TO_DELIVER' },
  { key: 'to_read', label: 'CAMPANHAS.TIMES.TO_READ' },
  { key: 'to_reply', label: 'CAMPANHAS.TIMES.TO_REPLY' },
];

const rows = computed(() =>
  ROWS.map(row => {
    const time = props.times?.[row.key] || {};
    return {
      ...row,
      p50: time.p50 ?? null,
      p90: time.p90 ?? null,
      samples: time.samples || 0,
      reason: campanhasLabel(t, 'reason', time.reason),
    };
  })
);
</script>

<template>
  <AnalyticsPanel
    data-test-id="campanha-tempos"
    :title="t('CAMPANHAS.TIMES.TITLE')"
    :description="t('CAMPANHAS.TIMES.DESCRIPTION')"
  >
    <p v-if="failed" class="mb-0 text-sm text-n-ruby-11">
      {{ t('ATENDIMENTO_REPORTS.FAILED') }}
    </p>
    <dl v-else-if="times" class="grid gap-4 m-0 sm:grid-cols-3">
      <div
        v-for="row in rows"
        :key="row.key"
        :data-test-id="`campanha-tempo-${row.key}`"
        class="flex flex-col gap-1 min-w-0"
      >
        <dt class="text-xs text-n-slate-11">{{ t(row.label) }}</dt>
        <dd class="flex flex-col gap-0.5 m-0">
          <span class="text-xl font-medium tabular-nums text-n-slate-12">
            <MetricValue
              :value="row.p50"
              :format="duration"
              :reason="row.reason"
            />
          </span>
          <span
            v-if="typeof row.p90 === 'number'"
            class="text-xs text-n-slate-11"
          >
            {{
              t(
                'CAMPANHAS.TIMES.P90',
                { time: duration(row.p90), count: number(row.samples) },
                row.samples
              )
            }}
          </span>
        </dd>
      </div>
    </dl>
  </AnalyticsPanel>
</template>
